import type { DataToolProps } from '@ztechapps/webui.data-tools'
import { DataTool } from '@ztechapps/webui.data-tools'
import { useConversationInboxContext } from './Context'

export const ConversationListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { chatList, onRefresh, filterCategory, fieldConfig } = useConversationInboxContext()

  return (
    <DataTool
      fieldsConfig={fieldConfig}
      searchPlaceHolder={searchPlaceHolder ?? 'Search conversations'}
      filterCategory={filterCategory}
      onRefresh={onRefresh}
      {...chatList}
      {...props}
      onSort={null}
    />
  )
}
